export default __webpack_public_path__ + "static/media/error-icon.890153ca.svg";